import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { DatabaseFieldType, DEFAULT_ENTRY_ID } from '@databases/types/database';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';
import { applyDeltaValue } from '../../utils/apply-delta-value.ts';
import { getConvertedValue } from '../../utils/get-converted-value.ts';
import { getOrSetValue } from '../../utils/get-or-set-value.ts';

export const setValue: YJSChangeHandler<DatabaseChangeType.SET_VALUE> = ({
  ydb,
  change,
  state
}) => {
  const delta = change.change;

  if (!delta) {
    return;
  }

  const destType = dbFieldTypeMap[delta.type];

  if (!destType) {
    throw new Error('unsupported type ' + destType);
  }

  const convertedValue = getConvertedValue(
    ydb,
    change.fieldId,
    (change.entryId === DEFAULT_ENTRY_ID
      ? ydb.defaultEntry
      : ydb.entriesById[change.entryId]
    ).getValue(change.fieldId),
    destType,
    state
  );

  ydb.mutate((db) => {
    const entry =
      change.entryId === DEFAULT_ENTRY_ID
        ? db.defaultEntry
        : db.entriesById[change.entryId];

    const field = db.fieldsById[change.fieldId];

    if (!entry || !field) {
      return;
    }

    applyDeltaValue(
      (destType) => getOrSetValue(entry, change.fieldId, destType, convertedValue),
      delta,
      delta.type === DatabaseFieldType.AI_SUMMARY
        ? {
            // Redux SET_VALUE represents a user edit; AI writes use the actor-aware AIFC path.
            markAiSummaryAsUserUpdated: true,
            userAccountId: state?.context.context?.userId
          }
        : undefined
    );
  });
};
